import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ToasterService } from '../../services/toaster/toaster.service';

@Component({
  selector: 'app-transaction-cancel',
  templateUrl: './transaction-cancel.component.html',
  styleUrls: ['./transaction-cancel.component.sass']
})
export class TransactionCancelComponent implements OnInit {
  
  constructor(
    private router: Router,
    private toasterService: ToasterService
  ) { }

  ngOnInit(): void {
    // Show info message
    this.toasterService.show('info', 'Payment cancelled. You can try again when you\'re ready.');
  }

  /**
   * Navigate to the billing page
   */
  goToBilling(): void {
    this.router.navigate(['/billing']);
  }

  /**
   * Navigate to the dashboard
   */
  goToDashboard(): void {
    this.router.navigate(['/dashboard']);
  }
}